module.exports = __webpack_public_path__ + "img/fondo-know.939dcca5.png";